import { memo } from "react";
import { isPaperThemeActive } from "@/hooks/useThemeFlag";
import { PaperStatusChip } from "@/components/paper/PaperStatusChip";

// Phase 1: Fly VM boot (POST /app/agentica-chat)
export const VM_BOOT_LABEL = "Setting up your environment…";

// Phase 2: Agent runtime startup (POST /api/chat)
export const REPLICA_WARMUP_LABEL = "Starting your agent…";

export const StartupStatusBanner = memo(function StartupStatusBanner({
  status,
}: {
  status: string;
}) {
  if (isPaperThemeActive()) {
    return (
      <div className="animate-in fade-in slide-in-from-bottom-1 duration-200">
        <PaperStatusChip
          leading={
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--fg-3)] animate-pulse" />
          }
        >
          <span key={status} className="animate-in fade-in duration-300 working-shimmer">
            {status}
          </span>
        </PaperStatusChip>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2 border-b border-white/[0.06] bg-white/[0.03] px-4 py-2 text-xs animate-in fade-in slide-in-from-bottom-1 duration-200">
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-zinc-400 animate-pulse" />
      <span key={status} className="animate-in fade-in duration-300">
        <span className="working-shimmer">{status}</span>
      </span>
    </div>
  );
});
